window.pagination = (url) => {
  return {
    isLoading: false,
    entries: [],
    pagination: [],
    paginationItems: '',
    url,
    get totalPages() {
      return this.pagination.total_pages;
    },
    get currentPage() {
      return this.pagination.current_page;
    },
    get pages() {
      return Array.from(Array(this.paginationItems), (_, i) => i + 1);
    },
    get previous() {
      return this.pagination.links ? this.pagination.links.previous : null;
    },
    get next() {
      return this.pagination.links ? this.pagination.links.next : null;
    },
    viewPage(page) {
      this.loadData(page);
    },
    async loadData(url = this.url) {
      const response = await fetch(url);
      const { data, meta } = await response.json();
      this.entries = data;
      this.pagination = meta.pagination;
			this.paginationItems = this.pagination.total_pages
			this.isLoading = true
    },
  };
};
